import { useState, useEffect } from 'react';
import RModal from '../../../components/Rsuite/Modal';
import { CustomButton } from '../../../components/CustomButton';
import { useAuth } from '../../../hooks/auth';
import api from '../../../services/api';
import RNavbar from '../../../components/Rsuite/Navbar';
import DadosCupom from './Dados';
import HorariosCupom from './Schedules';
import { toastSuccess, toastError } from '../../../toasts';

const dataAtivo = [
  { value: '0', label: 'Não' },
  { value: '1', label: 'Sim' },
];

function EditarCadastrarCupom({ modal, close, cupom, setCupons }) {
  const [active, setActive] = useState('dados');
  const { id_empresa } = useAuth();
  const [codigoPromo, setCodigoPromo] = useState(null);
  const [descricao, setDescricao] = useState(null);
  const [tipoDesconto, setTipoDesconto] = useState(1);
  const [valor, setValor] = useState(null);
  const [utilizacaoMax, setUtilizacaoMax] = useState(0);
  const [utilizacaoMaxCliente, setUtilizacaoMaxCliente] = useState(1);
  const [valorMinCompra, setValorMinCompra] = useState(0);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [ativo, setAtivo] = useState('0');

  const editarCupom = async () => {
    if (codigoPromo && descricao && valor && dataInicio && dataFim) {
      await api
        .patch(`cupom/alterar/${cupom.Id}`, {
          CodigoPromo: codigoPromo,
          Descricao: descricao,
          TipoDesconto: tipoDesconto,
          Valor: valor,
          UtilizacaoMaxima: utilizacaoMax,
          UtilizacaoMaxPorCliente: utilizacaoMaxCliente,
          ValorMinimoCompra: valorMinCompra,
          DataInicial: dataInicio,
          DataFinal: dataFim,
          Ativo: Number(ativo) === 1,
        })
        .then((res) => {
          toastSuccess('Cupom alterado com sucesso!');
          setCupons((state) => state.map((e) => (e.Id !== res.data.Id ? e : res.data)));
          close();
        });
    } else {
      toastError('Preencha todos os campos obrigatórios');
    }
  };

  const cadastrarCupom = async () => {
    if (
      codigoPromo &&
      descricao &&
      valor &&
      dataInicio &&
      dataFim
    ) {
      await api
        .post('cupom/criar', {
          IdEmpresa: id_empresa,
          CodigoPromo: codigoPromo,
          Descricao: descricao,
          TipoDesconto: tipoDesconto,
          Valor: valor,
          UtilizacaoMaxima: utilizacaoMax,
          UtilizacaoMaxPorCliente: utilizacaoMaxCliente,
          ValorMinimoCompra: valorMinCompra,
          DataInicial: dataInicio,
          DataFinal: dataFim,
          Ativo: Number(ativo) === 1,
        })
        .then((res) => {
          toastSuccess('Cupom cadastrado com sucesso!');
          setCupons((state) => [...state, res.data]);
          close();
        });
    } else {
      toastError('Preencha todos os campos obrigatórios');
    }
  };

  useEffect(() => {
    if (cupom) {
      setCodigoPromo(cupom.CodigoPromo);
      setDescricao(cupom.Descricao);
      setTipoDesconto(cupom.TipoDesconto);
      setValor(cupom.Valor);
      setUtilizacaoMax(cupom.UtilizacaoMaxima);
      setUtilizacaoMaxCliente(cupom.UtilizacaoMaxPorCliente);
      setValorMinCompra(cupom.ValorMinimoCompra);
      setDataInicio(cupom.DataInicial);
      setDataFim(cupom.DataFinal);
      setAtivo(cupom.Ativo ? dataAtivo[1].value : dataAtivo[0].value);
    }
  }, [cupom]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={cupom ? 'Editar Cupom' : 'Cadastrar Cupom'}
      footer={
        <>
          <CustomButton
            onClick={cupom ? editarCupom : cadastrarCupom}
            appearance="primary"
          >
            {cupom ? 'Alterar' : 'Cadastrar'}
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <RNavbar
        active={active}
        setActive={setActive}
        navItens={[
          {
            key: 'dados',
            name: 'Dados',
            disabled: false,
            hidden: false,
          },
          cupom && {
            key: 'horarios',
            name: 'Horários',
            disabled: !cupom,
            hidden: true,
          },
        ]}
      />
      {active === 'dados' && <DadosCupom
        codigoPromo={codigoPromo}
        setCodigoPromo={setCodigoPromo}
        descricao={descricao}
        setDescricao={setDescricao}
        setTipoDesconto={setTipoDesconto}
        cupom={cupom}
        valor={valor}
        setValor={setValor}
        utilizacaoMax={utilizacaoMax}
        setUtilizacaoMax={setUtilizacaoMax}
        utilizacaoMaxCliente={utilizacaoMaxCliente}
        setUtilizacaoMaxCliente={setUtilizacaoMaxCliente}
        valorMinCompra={valorMinCompra}
        setValorMinCompra={setValorMinCompra}
        dataInicio={dataInicio}
        setDataInicio={setDataInicio}
        dataFim={dataFim}
        setDataFim={setDataFim}
        dataAtivo={dataAtivo}
        setAtivo={setAtivo}
      />}
      {active === 'horarios' && <HorariosCupom cupom={cupom} />}
    </RModal>
  );
}

export default EditarCadastrarCupom;
